/**
 * Query keys of the auth service. A module of its own, with no imports, so the
 * AuthProvider can fill the cache without pulling in the hooks (which import it).
 */

/** `GET /api/user/me` — the profile the header, fees and settings read. */
export const USER_PROFILE_QK = ['userProfile'] as const;
